import { registerPlugin } from '@capacitor/core';
export const AppleLLM = registerPlugin('AppleLLM');
export * from './definitions';
//# sourceMappingURL=index.js.map